export const environment = {
  production: false,
  apiUrl: 'https://dev-api.global-ipcert.com/api',
  webUrl: 'https://dev.global-ipcert.com'
};
